// OPEN MODAL - v1.0 - August 2024 - Vanilla !
document.addEventListener('DOMContentLoaded', function() {


	function prepareModalsButtons(selector) {

		const DEV = 0;

		const modal_btns = document.querySelectorAll(selector);
		if (modal_btns.length === 0) {
			DEV && log('No modal buttons found with selector', selector);
			return;
		}


		modal_btns.forEach(modal_btn => {

			// define related modal
			const related_modal_name = modal_btn.getAttribute('open-modal')
			const related_modal = document.querySelector('dialog.'+ related_modal_name );

			DEV && log('related_modal_name', related_modal_name)
			DEV && log('related_modal', related_modal)


			modal_btn.addEventListener('click', function() {
				openModal(related_modal)
			})

			// button.close action
			const close_btn = document.querySelector('dialog.'+ related_modal_name + ' button.close' );
			close_btn.addEventListener('click', function() {
				related_modal.close();		
			})

			
			related_modal.addEventListener('close', function() {

				// unfix (here, so the escape key also unfixes the body)
				unfix_body();	

				// remove hash & other query from url
				const actual_short_url = window.location.origin + window.location.pathname
				DEV && log('actual_short_url', actual_short_url)
				window.history.pushState('', '', actual_short_url);

			})
		})
	}
	prepareModalsButtons('button[open-modal]');





	function openModal(modal) {

		// show modal
		modal.showModal();

		// fix body to avoid its scrolling
		fix_body_to_actual_y_position();
	}





	// AUTO OPEN MODALS
	const array_of_auto_modals = [
		'newsletter',
		'search'
	]

	// 3. Au fresh load d'un url d'une page au template OpenLightbox via page-open-lightbox.php
	array_of_auto_modals.forEach(function(modal_slug){
		if(location.hash === '#modal_' + modal_slug) {
			openModal(document.querySelector('dialog.'+ modal_slug ))
		}
	})


})